import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { ReadDealResponse } from '@/types'

export async function readDeal(dealKey: string) {
  const response = await httpClient('accounting-dealer').get<ReadDealResponse>(
    `/v3/deal/${dealKey}`,
  )

  return response.data
}

export function useReadDeal(
  dealKey: string,
  options?: Partial<UseQueryOptions<ReadDealResponse>>,
) {
  return useQuery({
    queryKey: ['deal', dealKey],
    queryFn: () => readDeal(dealKey),
    ...options,
  })
}
